import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SubrentalCutoffDetailRegisterTable } from 'src/app/models/tables/subrental/subrental-cutoff-detail-register-table.model';
import { SubrentalCutoffStoreModalModel } from 'src/app/models/tables/subrental/subrental-cutoff-store-modal.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubrentalCutoffDetailService {

  private readonly _httpClient = inject(HttpClient);

  createSubrentalCutoffDetail(subrentalCutoffId: number, storeIds: Array<number>): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.CreateSubrentalCutoffDetail}/${subrentalCutoffId}`,
      storeIds);
  }

  deleteSubrentalCutoffDetail(subrentalCutoffDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.DeleteSubrentalCutoffDetail}`,
      subrentalCutoffDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllSubrentalCutoffDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.GetAllSubrentalCutoffDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForRegisterTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.GetColumnsForRegisterTable}`);
  }

  getColumnsForStores(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.GetColumnsForStores}`);
  }

  getStoresForSubrentalCutoffAsync(subrentalCutoffId: number, page: number, limit: number,
    columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<SubrentalCutoffStoreModalModel>> {
    const params = new HttpParams().set('subrentalCutoffId', subrentalCutoffId).set('page', page)
      .set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<SubrentalCutoffStoreModalModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.GetStoresForSubrentalCutoffAsync}`,
      filters, { params: params }
    );
  }

  getSubrentalCutoffDetailsForRegisterTable(page: number, limit: number, columnSort: string | null, ascendant: boolean,
    subrentalCutoffId: number, filters: ColumnResponseModel[]): Observable<PagedResponseModel<SubrentalCutoffDetailRegisterTable>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<SubrentalCutoffDetailRegisterTable>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalCutoffDetail.GetSubrentalCutoffDetailsForRegisterTable}/${subrentalCutoffId}`,
      filters, { params: params }
    );
  }

}
